/* AMESCENSE VIBE LAYER v2 — background skulls + live BOGO nudge.
   No cursor hijack, no hover effects. Skull layer sits at z-index:-1,
   genuinely BEHIND product tiles and text. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SKULL = '☠︎';
  var BOGO_HANDLE = '☠︎︎buy-two-get-one-free-☠︎︎-copy';

  /* ---------- ghost skulls, behind the UI ---------- */
  function initSkulls() {
    if (reduceMotion) return;
    var layer = document.createElement('div');
    layer.className = 'vibe-skulls';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    var MAX = 9;
    function spawn() {
      if (document.hidden || layer.childElementCount >= MAX) return;
      var g = document.createElement('span');
      g.className = 'vibe-skull';
      g.textContent = SKULL;
      var size = 22 + Math.random() * 66;           /* 22–88px */
      var dur = 5 + Math.random() * 5;              /* 5–10s */
      g.style.fontSize = size + 'px';
      g.style.left = (Math.random() * 95) + '%';
      g.style.top = (Math.random() * 92) + '%';
      g.style.setProperty('--rot', (Math.random() * 36 - 18) + 'deg');
      g.style.setProperty('--dur', dur + 's');
      layer.appendChild(g);
      setTimeout(function () { g.remove(); }, dur * 1000 + 120);
    }
    for (var i = 0; i < 5; i++) setTimeout(spawn, i * 380);
    setInterval(spawn, 1000);
  }

  /* ---------- live BOGO nudge ---------- */
  function bogoMessage(n) {
    if (n <= 0) return '<span class="skull">☠︎</span> BUY 2 GET 1 FREE + FREE SHIPPING — ALL TEES';
    var r = n % 3;
    if (r === 2) return '<span class="skull">☠︎</span> ADD 1 MORE TEE — YOUR 3RD IS FREE + FREE SHIPPING';
    if (r === 1) return '<span class="skull">☠︎</span> ADD 2 MORE TEES — YOUR 3RD IS FREE + FREE SHIPPING';
    return '<span class="skull">☠︎</span> FREE TEE + FREE SHIPPING UNLOCKED <span class="skull">☠︎</span>';
  }

  var eligibleIds = null;
  function loadEligible() {
    if (eligibleIds) return Promise.resolve(eligibleIds);
    try {
      var cached = sessionStorage.getItem('vibeBogoIds');
      if (cached) { eligibleIds = JSON.parse(cached); return Promise.resolve(eligibleIds); }
    } catch (e) {}
    return fetch('/collections/' + encodeURIComponent(BOGO_HANDLE) + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        eligibleIds = (data.products || []).map(function (p) { return p.id; });
        try { sessionStorage.setItem('vibeBogoIds', JSON.stringify(eligibleIds)); } catch (e) {}
        return eligibleIds;
      })
      .catch(function () { return (eligibleIds = []); });
  }

  function refreshNudges() {
    var nodes = document.querySelectorAll('[data-bogo-nudge]');
    if (!nodes.length) return;
    Promise.all([loadEligible(), fetch('/cart.js').then(function (r) { return r.json(); })])
      .then(function (res) {
        var ids = res[0], cart = res[1], n = 0;
        (cart.items || []).forEach(function (it) {
          if (ids.indexOf(it.product_id) !== -1) n += it.quantity;
        });
        nodes.forEach(function (el) {
          el.innerHTML = bogoMessage(n);
          el.classList.toggle('vibe-bogo-nudge--unlocked', n > 0 && n % 3 === 0);
        });
      });
  }

  function initNudge() {
    if (!document.querySelector('[data-bogo-nudge]')) return;
    document.addEventListener('cart:updated', refreshNudges);
    document.addEventListener('cart:quantity', refreshNudges);
    document.addEventListener('ajaxProduct:added', refreshNudges);
    refreshNudges();
  }

  function boot() { initSkulls(); initNudge(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
